<div class="modal-header">
  <h4 class="modal-title pull-left">Edit Details</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div>

    <div class="form-group margin-bottom-20">
      <label class="form-label">Email Address</label>
      <input class="form-control" [ngModel]="email" disabled type="text" autocomplete="off">
    </div>
  </div>

  <div class="margin-bottom-20 div-with-separator">
    <label class="form-label"><b>Offering Memorandum Access</b></label>
    <label class="custom-checkbox margin-bottom-10" for="checkbox14" *ngIf="OMApproval">
      <input [(ngModel)]="OmApprovalChecked" type="checkbox" [ngClass]="{'disableConfidentialityAgreement':DisableOMAcceptButton}" [disabled]="DisableOMAcceptButton" (change)="changeOMAccess(1,OmApprovalChecked)"><span [ngClass]="{'disableConfidentialityAgreementText':DisableOMAcceptButton}">Approve &nbsp;</span>
      <i></i>
    </label>
    <label class="custom-checkbox margin-bottom-10" for="checkbox14" *ngIf="OMApproval">
      <input  [(ngModel)]="OmApprovalRejected"  [disabled]="DisableOMRejectButton" [ngClass]="{'disableConfidentialityAgreement':DisableOMRejectButton}" type="checkbox" (change)="changeOMAccess(2,OmApprovalRejected)"><span [ngClass]="{'disableConfidentialityAgreementText':DisableOMRejectButton}">Reject</span>
      <i></i>
    </label>
  </div>
  <div class="margin-bottom-20">
    <label class="form-label"><b>Due Diligence Access</b></label>
    <label class="custom-checkbox margin-bottom-15" for="checkbox14" *ngIf="DDApproval">
      <input [(ngModel)]="DDApprovalChecked" type="checkbox" [disabled]="DisableDDAcceptButton" [ngClass]="{'disableConfidentialityAgreement':DisableDDAcceptButton}" (change)="changeDDAccess(1,DDApprovalChecked)"><span [ngClass]="{'disableConfidentialityAgreementText':DisableDDAcceptButton}">Approve &nbsp;</span>
      <i></i>
    </label>
    <label class="custom-checkbox margin-bottom-15" for="checkbox14" *ngIf="DDApproval">
      <input [(ngModel)]="DDApprovalRejected" [disabled]="DisableDDRejectButton" [ngClass]="{'disableConfidentialityAgreement':DisableDDRejectButton}" type="checkbox" (change)="changeDDAccess(2,DDApprovalRejected)"><span [ngClass]="{'disableConfidentialityAgreementText':DisableDDRejectButton}">
        Reject
      </span>
      <i></i>
    </label>

  </div>
  <div *ngIf="CAApproval" class="margin-bottom-15">
    <label class="custom-checkbox margin-bottom-15" for="checkbox14">
      <input [(ngModel)]="IsConfidentialityAgreementChecked" type="checkbox" (change)="showUpload()">Confidentiality Agreement Signed
      <i></i>
    </label>
    <h6 class="mr-auto d-flex margin-bottom-0" *ngIf="!IsConfidentialityAgreementChecked&&currentDocAccessRequest?.CADocumentPath">
      <i container="body" class="userpermissiontooltip margin-right-5" aria-hidden="true" placement="right">
        <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
      </i>
      <span>Removing Confidentiality Agreement permission will delete the attached file permanently.</span>
    </h6>
  </div>
  <!--<div class="margin-bottom-20" *ngIf="(currentDocAccessRequest?.RequestForDueDiligenceAccess != 'New' || currentDocAccessRequest?.RequestForOfferAccess != 'New') && currentDocAccessRequest?.CADocumentPath&&IsConfidentialityAgreementChecked">
    <label class="custom-checkbox" for="checkbox14">
      <input [(ngModel)]="uploadNewCA" type="checkbox">Upload New Confidentiality Agreement
      <i></i>
    </label>
  </div>-->
  <div class="gray-box margin-bottom-20" *ngIf="(currentDocAccessRequest?.RequestForDueDiligenceAccess != 'New' || currentDocAccessRequest?.RequestForOfferAccess != 'New')&&currentDocAccessRequest?.CADocumentPath">
    <label class="form-label"><b>Uploaded Confidentiality Agreement</b></label>
    <span class="margin-bottom-10">
      <a triggers="hover" class="btn-border btn-view-portfolio margin-bottom-10" href={{currentDocAccessRequest?.CADocumentPath}} download="Document.pdf" target="_blank" ng-reflect-placement="top" ng-reflect-tooltip="Download" placement="top" tooltip="Download">
        <i aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{DisplayName}}
      </a>
    </span>
    <a *ngIf="IsConfidentialityAgreementChecked" class="bluelinkunderline no-underline" href="javascript:void(0);" style="font-size:11px !important;" (click)="UploadNewAgreement();">Replace</a>
  </div>
      
  <div class="mt_-15" *ngIf="CAApproval&& IsConfidentialityAgreementChecked&&uploadNewCA">
    <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [confidentialityAgreementTypes]="'pdf'" [maxFiles]="1" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
  </div>
  <div class="text-right margin-top-20">
    <button type="button" (click)="modalRef.hide()" class="btn btn-default btn-lg">Cancel</button>
    <button type="button" (click)="AddConfidentialiTyAgreement()" class="btn btn-success btn-lg">Save</button>
  </div>
</div>

